import {
    Component,
    forwardRef,
    Input,
    AfterContentInit,
    OnChanges,
    SimpleChanges,
    ContentChild,
    TemplateRef,
    SimpleChange,
    ViewChild,
    ElementRef
} from '@angular/core'
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms'
import { NgSelectComponent } from '@ng-select/ng-select'

const EMPTY_VALUE = undefined

@Component({
    selector: 'col-select',
    templateUrl: './select.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectComponent),
            multi: true
        }
    ]
})
export class SelectComponent
    implements OnChanges, ControlValueAccessor, AfterContentInit {
    @Input() options: any[]
    @Input() label: string
    @Input() notFoundMsg: string
    @Input() noFilter: number | boolean = 6
    @Input() emptyOption?: string
    @Input() placeholder?: string
    @Input() multiple?: boolean
    @Input() allowClear?: boolean

    @ContentChild('optionTemplate') itemTemplate: TemplateRef<any>
    @ViewChild(NgSelectComponent) select: NgSelectComponent
    @ViewChild('searchBox') searchBox: ElementRef

    selected: any
    disabled: boolean
    searchTerm: string
    useOptionTemplate = false
    optionsForNgSelect: any[]

    private onChange: any
    private onTouched: any
    private emptyOptionObj: any

    get searchable() {
        if (typeof this.noFilter === 'boolean') {
            return !this.noFilter
        }
        return this.options && this.options.length > this.noFilter
    }

    ngAfterContentInit() {
        this.useOptionTemplate = !!this.itemTemplate
    }

    ngOnChanges(changes: SimpleChanges) {
        this.handleChanges(changes)
    }

    onBlur() {
        if (!this.searchBox) {
            this.onTouched()
        }
    }

    onClose() {
        this.onTouched()
    }

    onSelect(value: any) {
        this.emitChanges()
    }

    writeValue(obj: any) {
        this.setSelected(obj)
    }

    registerOnChange(fn: any) {
        this.onChange = fn
    }

    registerOnTouched(fn: any) {
        this.onTouched = fn
    }

    setDisabledState?(isDisabled: boolean) {
        this.disabled = isDisabled
    }

    focusSearchBox() {
        if (this.searchable) {
            setTimeout(() => {
                this.searchBox.nativeElement.focus()
            })
        }
    }

    emitChanges() {
        if (this.isEmptyOptionObj(this.selected)) {
            this.onChange(EMPTY_VALUE)
        } else {
            this.onChange(this.selected)
        }
    }

    isEmptyOptionObj(item: any) {
        return this.emptyOption && item === this.emptyOptionObj
    }

    private handleChanges(changes: SimpleChanges) {
        if ('options' in changes) {
            this.optionsForNgSelect = (this.options || []).slice()
            if (this.emptyOptionObj) {
                this.optionsForNgSelect.unshift(this.emptyOptionObj)
            }
        }

        if ('emptyOption' in changes) {
            if (this.emptyOption) {
                if (!this.emptyOptionObj) {
                    this.createEmptyOptionObj()
                }
            } else {
                if (this.emptyOptionObj) {
                    this.removeEmptyOptionObj()
                }
            }
        }
    }

    private setSelected(obj: any) {
        if (obj === EMPTY_VALUE && this.emptyOption) {
            this.selected = this.emptyOptionObj
        } else {
            this.selected = obj
        }
    }

    private createEmptyOptionObj() {
        this.emptyOptionObj = {
            value: 'empty',
            label: this.emptyOption
        }

        createProp(this.emptyOptionObj, this.label, this.emptyOption)

        this.optionsForNgSelect.unshift(this.emptyOptionObj)
    }

    private removeEmptyOptionObj() {
        this.optionsForNgSelect.splice(0, 1)
        this.emptyOptionObj = undefined
    }
}

function createProp(obj: any, propPath: string, value: any) {
    const parts = propPath.split('.')
    const currProp = parts.shift()

    if (parts.length === 0) {
        obj[currProp] = value
    } else {
        obj[currProp] = {}
        createProp(obj[currProp], parts.join('.'), value)
    }
}



// WEBPACK FOOTER //
// ./src/app/common/select/select.component.ts